import { METHOD, webRequest } from '../../client/HttpClient';
import { API } from '../../client/RouteConstants';
import { buildProductMetadataQuery, buildURL, logAPIErrorToNewrelic } from '../utils';
import { ACTION, Analytics } from '../../analytics/analytics';
import { APIResult } from '../APIResult';

export const deleteItemFromWishList = async (
    wishListId: string,
    skuId: string,
    productMetadata?: ProductMetadata | undefined,
): Promise<APIResult<WishListItem>> => {
    const productMetadataQuery = buildProductMetadataQuery(productMetadata);
    const url = buildURL(`${API.WISH_LISTS}/${wishListId}/items/${skuId}?lite=true${productMetadataQuery}`);

    const request: RequestInit = {
        method: METHOD.DELETE,
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const res = await webRequest(url, request);

    const result = new APIResult<WishListItem>();
    if (!res) {
        logAPIErrorToNewrelic(`deleteItemFromWishList`, `No response`, {
            skuId: skuId,
            wishListId: wishListId,
            ...request,
            url: url,
            productMetadata: productMetadata,
            response: res,
        });
        return result;
    }

    if (res.status === 401) {
        result.showError = false;
    }

    if (res.ok) {
        Analytics.dispatchAdobeAnalytics(ACTION.REMOVE_FROM_WISH_LIST);
        result.data = await res.json();
        result.success = true;
    } else {
        logAPIErrorToNewrelic(`deleteItemFromWishList`, `Not Ok response`, {
            skuId: skuId,
            wishListId: wishListId,
            request: request,
            reqUrl: url,
            productMetadata: productMetadata,
            ...res,
        });
    }

    return result;
};
